import {Action} from '@ngrx/store';
import {IDealerInfo} from '@signal/asp-data-commons';
import { StateDetails } from './../../shared/models/state';

export enum DealerTypes {
  LOAD_DEALER_DETAILS = '[General Settings API] fetch sales and service settings from dealer Admin',
  LOAD_DEALER_DETAILS_SUCCESS = '[General Settings API] fetch sales and service settings from dealer Admin success',
  LOAD_DEALER_DETAILS_FAILURE = '[General Settings API] fetch sales and service settings from dealer Admin failure',
  LOAD_STATES = '[General Settings API] fetch States',
  LOAD_STATES_SUCCESS = '[General Settings API] fetch States success',
  LOAD_STATES_FAILURE = '[General Settings API] fetch States failure',
  LOAD_CITIES = '[General Settings API] fetch cities',
  LOAD_CITIES_SUCCESS = '[General Settings API] fetch cities success',
  LOAD_CITIES_FAILURE = '[General Settings API] fetch cities failure',
  LOAD_DASHBOARD_CONTENTS='[General Settings API] fetch dashboardcontents',
  LOAD_DASHBOARD_CONTENTS_SUCCESS = '[General Settings API] fetch dashboardcontents success',
  LOAD_DASHBOARD_CONTENTS_FAILURE = '[General Settings API] fetch dashboardcontents failure'
}

export class LoadDealerDetails implements Action {
  readonly type: string = DealerTypes.LOAD_DEALER_DETAILS;

  constructor(public payload: {dealerCode: string}) {
  }
}

export class LoadDealerDetailsSuccess implements Action {
  readonly type: string = DealerTypes.LOAD_DEALER_DETAILS_SUCCESS;

  constructor(public payload: { dealerInfo: IDealerInfo }) {
  }
}

export class LoadDealerDetailsFail implements Action {
  readonly type: string = DealerTypes.LOAD_DEALER_DETAILS_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class LoadStatesDetails implements Action {
  readonly type: string = DealerTypes.LOAD_STATES;

  constructor() {
  }
}

export class LoadStatesDetailsSuccess implements Action {
  readonly type: string = DealerTypes.LOAD_STATES_SUCCESS;

  constructor(public payload: { states: StateDetails[] }) {
  }
}

export class LoadDashboardOverlayContentsSuccess implements Action {
   type: string = DealerTypes.LOAD_DASHBOARD_CONTENTS_SUCCESS;

  constructor(public payload: { contents: any[] }) {
  }
}
export class LoadDashboardOverlayContentsFailure implements Action {
   type: string = DealerTypes.LOAD_DASHBOARD_CONTENTS_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class LoadStatesDetailsFail implements Action {
  readonly type: string = DealerTypes.LOAD_STATES_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class LoadCityDetails implements Action {
  readonly type: string = DealerTypes.LOAD_CITIES;

  constructor() {
  }
}

export class LoadCityDetailsSuccess implements Action {
  readonly type: string = DealerTypes.LOAD_CITIES_SUCCESS;

  constructor(public payload: { cities: { [key: string]: string[]} }) {
  }
}

export class LoadCityDetailsFail implements Action {
  readonly type: string = DealerTypes.LOAD_CITIES_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class LoadOverlayDashboardContents implements Action {
  type: string = DealerTypes.LOAD_DASHBOARD_CONTENTS;

  constructor() {
  }
}

export type DealerType =
  LoadDealerDetails
  | LoadDealerDetailsSuccess
  | LoadDealerDetailsFail
  | LoadStatesDetails
  | LoadStatesDetailsSuccess
  | LoadStatesDetailsFail
  | LoadCityDetails
  | LoadCityDetailsSuccess
  | LoadCityDetailsFail
  | LoadOverlayDashboardContents
  | LoadDashboardOverlayContentsSuccess
  | LoadDashboardOverlayContentsFailure
  ;
